import React from 'react'
import { Image, Container } from 'semantic-ui-react'
import PageHeader from '../components/PageHeader'
import ShowReviews from '../components/ShowReviews'
import FreeEstimate from '../components/FreeEstimate'

export default function Services() {
  return (
    <>
      <PageHeader
        title="Our Services"
        // description="Highly Skilled and Friendly"
        image="/images/tree-chipper.jpg"
      />
      <Container>
        <div className="our-services">
          <Image.Group style={{ textAlign: 'center' }}>
            <Image src="/images/our-tree-removal.jpg" />
            <Image src="/images/our-trimming.jpg" />
          </Image.Group>
          <Image.Group style={{ textAlign: 'center' }}>
            <Image
              src="/images/our-stump-grinding.jpg"
              style={{ height: '260px' }}
            />
            <Image src="/images/our-chipping.jpg" />
          </Image.Group>
          <Image.Group style={{ textAlign: 'center' }}>
            <Image src="/images/our-friendly-service.jpg" />
          </Image.Group>
        </div>
      </Container>
      <ShowReviews />
      <FreeEstimate />
    </>
  )
}
